

import React, { useState } from 'react';
import {  useGetStatsQuery } from '../api/accountsAPI';
import { Alert, Button, Card } from "react-bootstrap";
import { LoaderComponent } from '../components/LoaderComponent';
import { Icon } from '../components/ui/Icon';
import { UserStats } from '../api/types/accounts';
import { TopLevelSpec } from 'vega-lite';
import { VegaLite } from 'react-vega';
import {fr} from "date-fns/locale";

interface PageProps {

}

interface AccountStatsProps {
   stats: UserStats
}

type KeyOfStats = keyof UserStats;

const metricsLabels : Partial<Record<KeyOfStats,string>> = {
   users_active: "Count of active users",
   users_count:"Total count of registred users",
   users_newsletter:"Active users with newsletter subscription",
   users_weekly: "Active users with weekly subscription",
   profiles_count: "Profiles in accounts",
   profiles_active: "Profiles in active accounts",
}

export const AccountStats: React.FC<AccountStatsProps> = (props) => {
   
   const showMetric =(n: keyof UserStats)=> {
      const v = (n in props.stats) ? props.stats[n] : '';
      const label = metricsLabels[n] ?? n;
      return <tr key={n}>
            <td>{label}</td>
            <td>{''+ v}</td>
      </tr>
   };

   const metrics : KeyOfStats[] = ['users_count','users_active','users_newsletter', 'users_weekly','profiles_count','profiles_active']

   const weekDayGraph = () => {
  
      const WeekDayData = props.stats['users_weekday'] ?? undefined;

      if(!WeekDayData) {
         return <></>;
      }

      const data = Object.entries(WeekDayData).map(v=> {return {'day': +v[0], 'dayname': fr.localize?.day(v[0]), 'value': v[1]}}).sort((a,b) => a.day - b.day)
      console.log(data);
      const vegaLiteSpec: TopLevelSpec = {
         $schema: 'https://vega.github.io/schema/vega-lite/v5.json',
         width:400,
         height: 200,
         title:"Weekday assigned for weekly reminder (active users)",
         data: {
            values: data
         },
         mark: 'bar',
            encoding: {
            x: {field: 'dayname', sort: {'field': 'day'}, type: 'nominal', "axis": {"labelAngle": 0, title:"Day of the week"}},
            y: {field: 'value', type: 'quantitative', "axis":{"title":"Users count"}},
         }
      };
      return <VegaLite spec={vegaLiteSpec}/>
   }

   const profilesGraph = () => {
  
      const profilesData = props.stats['profiles_histogram'] ?? undefined;

      if(!profilesData) {
         return <></>;
      }

      const data = Object.entries(profilesData).map(v=> {return {'size': +v[0], count:v[1] } });
      console.log(data);
      const vegaLiteSpec: TopLevelSpec = {
         $schema: 'https://vega.github.io/schema/vega-lite/v5.json',
         width:400,
         height: 200,
         title:"Users count by size of household in the account",
         data: {
            values: data
         },
         mark: 'bar',
            encoding: {
            x: {field: 'size', type: 'nominal', "axis": {"labelAngle": 0, title:"Size of household"}},
            y: {field: 'count', type: 'quantitative', "axis":{"title":"Users count"}},
         }
      };
      return <VegaLite spec={vegaLiteSpec}/>
   }

   return <Card>
      <Card.Body className='row'>
      <div className='col-4'>
      <table className='table table-stripped'>
         <caption>Users count ({props.stats.__time__})</caption>
         <tbody>
            { metrics.map(n => showMetric(n)) }
         </tbody>
      </table>
      </div>
      <div className='col-8'>
         { weekDayGraph() }
         { profilesGraph() }
      </div>
      </Card.Body>
   </Card>
}


export const AccountsPage: React.FC<PageProps> = (props) => {
   
   const {data, error, isLoading, refetch } = useGetStatsQuery()

   const handleRefresh = ()=> {
      refetch();
   }

   return ( 
      <React.Fragment>
         <h1>Accounts</h1>
         <div className='m-1'><Button onClick={handleRefresh} size="sm"><Icon name='sync'/> Actualiser</Button></div>
        <LoaderComponent isLoading={isLoading} error={error} />
        { data && data.data ?  <AccountStats stats={data.data}/> :''}
        { data && data.error ? <Alert variant='danger'>{data.error}</Alert> :''}
      </React.Fragment>
   )
};

